import {
  RecentlyCompletedClassesQueryQuery,
  RecentlyCompletedClassesQueryQueryVariables,
} from "@outschool/gql-frontend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";

import { EnrollmentWithSection } from "../components/loggedInHome/ClassList";
import { recentlyCompletedClassesQuery } from "../queries/RecentlyCompletedClassesQuery";

interface Props {
  filterByLearnerUid?: string | null;
  limit?: number;
}

const useRecentlyCompletedClassList = ({
  filterByLearnerUid,
  limit = 3,
}: Props) => {
  const {
    data: completedClassesData,
    loading: completedClassesLoading,
    error: completedClassesError,
  } = useQueryWithPreviousData<
    RecentlyCompletedClassesQueryQuery,
    RecentlyCompletedClassesQueryQueryVariables
  >(recentlyCompletedClassesQuery, {
    variables: {
      learnerUid: filterByLearnerUid,
      limit: limit + 1,
      endDate: new Date(),
    },
  });
  const completedClasses =
    completedClassesData?.currentUser?.enrollmentsForTranscript ?? [];

  return {
    completedClasses: completedClasses.slice(
      0,
      limit,
    ) as EnrollmentWithSection[],
    completedClassesLoading,
    completedClassesError,
    completedClassesTotalCount: completedClasses.length,
  };
};

export default useRecentlyCompletedClassList;
